module.exports = __webpack_public_path__ + "img/transportation-ua.3edac420.svg";